const svgW3 = 'http://www.w3.org/2000/svg';
export const newLine = alias => {
  const middleLine = document.createElementNS(svgW3, 'line');
  middleLine.setAttribute('id', 'line2');
  middleLine.setAttribute('class', `_middleLine${alias}`);
  middleLine.setAttribute('x1', '50%');
  middleLine.setAttribute('y1', '20%');
  middleLine.setAttribute('x2', '50%');
  middleLine.setAttribute('y2', '70%');
  middleLine.setAttribute('stroke', 'black');
  middleLine.setAttribute('stroke-dasharray', '4 1');
  return middleLine;
};
export const newLineTV = alias => {
  const middleLine = document.createElementNS(svgW3, 'line');
  middleLine.setAttribute('id', 'line2');
  middleLine.setAttribute('class', `_middleLine${alias}`);
  middleLine.setAttribute('x1', '50%');
  middleLine.setAttribute('y1', '20');
  middleLine.setAttribute('x2', '50%');
  middleLine.setAttribute('y2', '60%');
  middleLine.setAttribute('stroke', 'white');
  middleLine.setAttribute('stroke-dasharray', '0');
  return middleLine;
};
export const newText = (value, alias) => {
  const textSvg = document.createElementNS(svgW3, 'text');
  textSvg.setAttribute('id', 'svgText');

  textSvg.setAttribute('class', `textSvg textSvg${alias}`);
  textSvg.setAttribute('class', `_mayoria _mayoria${alias}`);
  textSvg.setAttribute('x', '50%');
  textSvg.setAttribute('y', '75%');
  textSvg.setAttribute('text-anchor', 'middle');
  const textNode = document.createTextNode('Mayoría absoluta');
  const textNode2 = document.createTextNode(Number(value).toLocaleString('es'));
  textSvg.appendChild(textNode);
  const tspanSvg = document.createElementNS(svgW3, 'tspan');
  tspanSvg.setAttribute('class', `textSvgNumber textSvgNumber${alias}`);
  tspanSvg.setAttribute('class', `_mayoria _mayoria${alias}`);
  tspanSvg.setAttribute('x', '50%');
  tspanSvg.setAttribute('y', '82%');
  tspanSvg.appendChild(textNode2);
  textSvg.append(tspanSvg);
  return textSvg;
};
export const newTextTV = (value, alias) => {
  const textSvg = document.createElementNS(svgW3, 'text');
  textSvg.setAttribute('id', 'svgText');

  textSvg.setAttribute('class', `textSvg textSvg${alias}`);
  textSvg.setAttribute('class', `_mayoria _mayoria${alias}`);
  textSvg.setAttribute('x', '50%');
  textSvg.setAttribute('y', '67%');
  textSvg.setAttribute('text-anchor', 'middle');
  const textNode = document.createTextNode('Mayoría absoluta');
  const textNode2 = document.createTextNode(Number(value).toLocaleString('es'));
  textSvg.appendChild(textNode);
  const tspanSvg = document.createElementNS(svgW3, 'tspan');
  tspanSvg.setAttribute('class', `textSvgNumber textSvgNumber${alias}`);
  tspanSvg.setAttribute('class', `_mayoria _mayoria${alias}`);
  tspanSvg.setAttribute('x', '50%');
  tspanSvg.setAttribute('y', '77%');
  tspanSvg.appendChild(textNode2);
  textSvg.append(tspanSvg);
  return textSvg;
};
